import React, { Component } from 'react';
import { Growl } from "primereact/growl";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Message } from "primereact/message";
import { Paginator } from 'primereact/paginator';
import { Dialog } from "primereact/dialog";
import { Lightbox } from 'primereact/lightbox';

import servicioHttp from "../servicio/ServicioHttp";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioArchivos from '../servicio/ServicioArchivos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';

const TODOS = { label: "Todos", value: 0 };

/**
 * Vista Lotes-CDUIDSE006
 */
export class Lotes extends Component {
    constructor() {
        super();
        this.state = {
            verModalConsultaLote: false,
            paginacion: { registrosPorPagina: 10, join: { "tcEmpresa": "alias_tcEmpresa", "ttUsuario": "alias_ttUsuario" } },
            idsenube: 0,
            registrosPatronales: [],
            errores: {},
            objetoConsulta: {},
            mostrarFecha: true,
            modalInformacionLote: false,
            solicitudIdse: {},
            listaMovimientos: [],
            listaTrMovimientos: [],
            contador: 0,
            iFrameSrc: null,
            activeIndex: 1

        };
    }

    componentDidMount() {
        this.registroPatronal();
    }

    /**
     * Método que llena el dropdown con los registros patronales
     */
    registroPatronal() {
        servicioHttp.consumirPostHttp("empresa/obtener_registro_patronal.json").then((response) => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { objetoConsulta } = this.state;
            objetoConsulta.empresa = TODOS.value;
            this.setState({ registrosPatronales: newArray, objetoConsulta: objetoConsulta });
        }).catch((error) => { });
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.buscar();
    }

    obtenerPagina() {        
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp("solicitud/consultas_con_movimientos.json", paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
        }).catch((error) => {
            this.growl.show({
                severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
            });
        });
    }

    asginarRestriccionesDinamicas = () => {
        let { paginacion,objetoConsulta,registrosPatronales } = this.state;       
        paginacion.ordenamientos = [];
        paginacion.ordenamientos.push({
            tipo: 'desc',
            nombrePropiedad: 'fecha'
        });
        let validacion= this.validarFomularioTodosRegistroFecha(objetoConsulta);
        this.setState({ errores: validacion });
        if (servicioAsignacionValoresObjetos.esObjetoVacio(validacion)) {
            paginacion['restriccionesDinamicas'] = [];
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.fechaInicial) && !servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.fechaFinal)) {
                let fechaIncial = servicioFormatos.formatearFechaString(objetoConsulta.fechaInicial);
                let fechaFinal = servicioFormatos.formatearFechaString(objetoConsulta.fechaFinal).replace('00:00:00', '23:59:59');
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "between", nombrePropiedad: "fecha",
                    fechaIncialBetween: fechaIncial, fechaFinalBetween: fechaFinal
                });
            }
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.empresa) && objetoConsulta.empresa !== 0) {
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "eq", nombrePropiedad: "alias_tcEmpresa.id",
                    valorPropiedad: objetoConsulta.empresa
                });
            } else {
                let empresasUsuarioSesion = [];
                for (let index = 0; index < registrosPatronales.length; index++) {
                    let elemento = registrosPatronales[index];
                    if (elemento.value !== 0) {
                        let valor = elemento.value;
                        empresasUsuarioSesion.push(
                            valor
                        );
                    }
                }
                paginacion.restriccionesDinamicas.push({
                    tipoRestriccion: "in",
                    nombrePropiedad: "alias_tcEmpresa.id",
                    coleccionIn: empresasUsuarioSesion
                });
            }
            if (!servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.loteIdImss)) {
                paginacion.restriccionesDinamicas.push(
                    {
                        tipoRestriccion: "eq", nombrePropiedad: "loteIdImss",
                        valorPropiedad: objetoConsulta.loteIdImss
                    });
            }
            this.setState({ paginacion });
            
        }
    }

    buscar = () => {    
        let {objetoConsulta}=this.state;
        let validacionFormulario= this.validarFomularioTodosRegistroFecha(objetoConsulta);
        this.setState({ errores: validacionFormulario });
        if (servicioAsignacionValoresObjetos.esObjetoVacio(validacionFormulario)) {
            this.asginarRestriccionesDinamicas();
            this.obtenerPagina();
        }
    }

    /**
     * Método que valida el formulario Todos,Registro Patronal,Fecha
     * @param {*} objetoConsulta 
     * @returns 
     */
    validarFomularioTodosRegistroFecha = (objetoConsulta) => {
        const errores = {};
        if (servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.loteIdImss)) {
            if (servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.empresa))
                errores.empresa = "Seleccione un tipo de Búsqueda";
            if (servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.fechaInicial))
                errores.fechaInicial = "Seleccione un tipo de Búsqueda";
            if (servicioAsignacionValoresObjetos.esObjetoVacio(objetoConsulta.fechaFinal))
                errores.fechaFinal = "Seleccione un tipo de Búsqueda";
        }

        return errores;
    }


    limpiarDatos = () => {
        let { paginacion, objetoConsulta } = this.state;
        paginacion['restriccionesDinamicas'] = [];
        paginacion['datos'] = [];
        paginacion['registrosTotales'] = 1;
        objetoConsulta = {};
        this.setState({ objetoConsulta: objetoConsulta, paginacion, idsenube: 0, mostrarFecha: false });
        setTimeout(() => {
            this.setState({ mostrarFecha: true });
        }, 200);
    }

    /**
     * Método encargado de obtener el dato (número de lote) que se ingresé (inputText)
     * para realizar la búsqueda.
     * 
     * @param {*} event 
     */
    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    };

    /**
     * Método que establece la equivalencia de un número en función de un estado:
     *               ____
     * 2 = Procesado     |
     * 1 = En proceso    |---> Estados
     * 0 = Rechazado ____|
     * 
     * @param {*} rowData 
     * @param {*} column 
     * @returns 
     */
    plantillaEstadoM(rowData, column) {
        return <p>{servicioFormatos.filtroEstadoLote(rowData.estado)}</p>
    }

    /**
     * Método que descarga en un zip, todos los Lotes de todos los registros patronales
     * o en su caso del registro patronal seleccionado.
     */
    descargarRespuesta() {
        let { paginacion } = this.state;
        let paginacionCopia = JSON.parse(JSON.stringify(paginacion))
        paginacionCopia.registrosPorPagina = 20000;
        paginacionCopia.numeroPagina = 0;
        servicioArchivos.descargaArchivo('solicitud/descarga_respuesta.json', paginacionCopia, this);
    }

    /**
     * Método que permite mostrar en vista previa el acuse de recibo electrónico y
     * la opción de poderlo descargar.
     * 
     * @param {*} elemento 
     */
    descargarAcuse = () => {
        let { solicitudIdse } = this.state;
        servicioArchivos.descargaArchivo("solicitud/descargarAcuse.json", solicitudIdse, this);
    }

    /**
     * Método que permite mostrar en vista previa la constancia de presentación de 
     * movimientos afiliatorios de manera global y la opción de poder descargarlo.
     */
    descargarConstancia = () => {
        let { solicitudIdse } = this.state;
        servicioArchivos.descargaArchivoComoBlob("solicitud/descargarAfil.json", { id: solicitudIdse.id }).then(response => {
            this.setState({ iFrameSrc: URL.createObjectURL(response) });
            document.getElementById("btnVisorPdfTarget").click();
        });
    }

    /**
     * Método que exporta un excel con los datos del lote.
     */
    descargarReporteExcel = () => {
        let { solicitudIdse } = this.state;
        servicioArchivos.descargaArchivo('solicitud/exportar_excel.json', solicitudIdse);
    }

    /**
     * Método que permite descargar un zip con el nombre del archivo del número de lote,
     * deberá contener las constancias de presentación de movimientos(AFIL),
     * de cada uno de los movimientos enviados.
     * 
     * @param {*} elemento 
     */
    descargarPdf = () => {
        let { solicitudIdse } = this.state;
        servicioArchivos.descargaArchivo("documentos/afil_individual_zip.json", { id: solicitudIdse.id }, this);
    }

    /**
     * Método que crea un botón (consultar) dentro de la tabla (ultima columna).
     * Al hacer clic, muestra modal resumen de lote.
     * 
     * @param {*} rowData 
     * @param {*} column 
     * @returns 
     */
    plantillaConsultar(rowData, column) {
        return (
            <div className="p-grid p-fluid" >
                <div className="p-col-12">
                    <Button
                        label="Consultar"
                        icon="pi-md-search"
                        tooltip="Consultar"
                        onClick={() => this.vizualizarInformacioLote(rowData)}
                    ></Button>
                </div>
            </div>
        );
    }

    vizualizarInformacioLote = (objeto) => {
        this.obtenerMovimientoSolicitud(objeto);

    }

    formatoIncremento = () => {
        let { contador } = this.state;
        return contador + 1;
    }

    formatoTipoMovimiento = (objeto) => {
        return <p>{servicioFormatos.formatoTipoMovimiento(objeto.tipoMovimiento)}</p>
    }

    formatofechaMovimiento = (objeto) => {

        return <p>{servicioFormatos.formatearFechaStringIdse(objeto.fechaMovimiento)}</p>
    }

    formatoTipoTrabajador = (objeto) => {
        return <p>{servicioFormatos.formatoTipoTrabajador(objeto.tipoTrabajador)}</p>
    }

    formatosdi = (objeto) => {
        return <p>{servicioFormatos.formatoSalarioDiarioIntegradoString(objeto.salarioDiarioIntegrado)}</p>
    }

    formatoTipoSalario = (objeto) => {
        return <p>{servicioFormatos.formatoTipoSalario(objeto.tipoSalario)}</p>
    }

    formatoTipoJornada = (objeto) => {
        return <p>{servicioFormatos.formatoTipoJornada(objeto.jornadaReducida)}</p>
    }

    formatoBaja = (objeto) => {
        return <p>{servicioFormatos.formatoCausaBaja(objeto.causaBaja)}</p>
    }

    formatoFecha = (objeto) => {
        return <p>{servicioFormatos.formatearFechaSinSegundos(objeto.fecha)}</p>
    }

    formatoFechaRespuesta = (objeto) => {
        return <p>{servicioFormatos.formatearFechaSinSegundos(objeto.fechaRespuesta)}</p>
    }

    formatoExtemporaneo = (objeto) => {
        return <p>{servicioFormatos.filtroExtemporaneo(objeto.extemporaneo)}</p>
    }

    templateNombre = (rowData, column) => {
        return servicioFormatos.formatearNombreTrabajador(rowData);
    }

    formatoEstado=(objeto)=>{
        let{solicitudIdse}=this.state
       return <p>{servicioFormatos.filtroEstadoMovimiento(objeto.estadoRespuesta,solicitudIdse.fechaRespuesta)}</p>
    }

    obtenerMovimientoSolicitud(objeto) {
        let loteSolicitud = {};
        loteSolicitud.id = objeto.id;
        let { listaMovimientos } = this.state;
        servicioHttp.consumirPostHttp("movimientos/consultar_movimientos.json", loteSolicitud).then((response) => {
            let labelIngresos = "Ingresos";
            let labelModificacione = "Modificaciones";
            let labelBajas = "Bajas";
            let contadorIngresos = 0;
            let contadorBajas = 0;
            let contadorModificaciones = 0;
            let contadorIgresosError = 0;
            let contadorBajasError = 0;
            let contadorModificacionesError = 0;
            let contadorIngresosAceptados = 0;
            let contadorBajasAceptados = 0;
            let contadorModificacionesAceptados = 0;
            for (var i = 0; i < response.data.objeto.datos.length; i++) {
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorBajas++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorIngresos++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionError === null) {
                    contadorModificaciones++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorBajasAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null&&  response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorIngresosAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionErrorAfil === null && response.data.objeto.datos[i].descripcionError === null &&  response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorModificacionesAceptados++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "02" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorBajasError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "08" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorIgresosError++;
                }
                if (response.data.objeto.datos[i].tipoMovimiento === "07" && response.data.objeto.datos[i].descripcionErrorAfil !== null && response.data.objeto.datos[i].estado === 1 && objeto.fechaRespuesta!==null) {
                    contadorModificacionesError++;
                }
                
            }

            listaMovimientos.push({ tipoMovimiento: labelIngresos, total: contadorIngresos, error: contadorIgresosError, aceptados: contadorIngresosAceptados },
                { tipoMovimiento: labelModificacione, total: contadorModificaciones, error: contadorModificacionesError, aceptados: contadorModificacionesAceptados },
                { tipoMovimiento: labelBajas, total: contadorBajas, error: contadorBajasError, aceptados: contadorBajasAceptados });

            this.setState({ modalInformacionLote: true, solicitudIdse: objeto, listaTrMovimientos: response.data.objeto.datos })

        }).catch(() => { });
    }


    /**
     * Método para reiniciar el formulario de Busqueda
     */
    reinicarConsultas = () => {
        let { paginacion, objetoConsulta } = this.state;
        paginacion['restriccionesDinamicas'] = [];
        paginacion['datos'] = [];
        paginacion['registrosTotales'] = 1;
        objetoConsulta = {};
        this.setState({ objetoConsulta: objetoConsulta, paginacion, idsenube: 0, mostrarFecha: false });
        setTimeout(() => {
            this.setState({ mostrarFecha: true });
        }, 200);
    }

    cerrarModalDetalleLote = () => {
        this.setState({ modalInformacionLote: false, listaMovimientos: [] });
    }

    render() {

        let { errores, idsenube, paginacion, objetoConsulta, mostrarFecha, modalInformacionLote, solicitudIdse, listaMovimientos,
            listaTrMovimientos, iFrameSrc } = this.state;

        let calendarioFechaIncial =
            <div className="p-col-12 p-md-4">
                <Calendar name="objetoConsulta.fechaInicial" value={objetoConsulta.fechaInicial || ''} placeholder="*Fecha Inicial"
                    onChange={this.asignarValores} className={errores.fechaInicial ? 'p-error' : ''}
                    locale={CALENDARIO_ES_MX} dateFormat={FORMATO_FECHA_CALENDAR} />
                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
            </div>;

        let calendarioFechaFinal =
            <div className="p-col-12 p-md-4">
                <Calendar name="objetoConsulta.fechaFinal" value={objetoConsulta.fechaFinal || ''} placeholder="*Fecha Final"
                    onChange={this.asignarValores} className={errores.fechaFinal ? 'p-error' : ''}
                    locale={CALENDARIO_ES_MX} dateFormat={FORMATO_FECHA_CALENDAR} />
                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
            </div>;

        const dialogFooter = (
            <div className="p-grid p-fluid" >
                <div className="P-col-12 p-md-3">
                    <Button icon="pi-md-import-export" onClick={this.descargarAcuse} label="Acuse" className="p-button flat-btn" />
                </div>
                <div className="P-col-12 p-md-3">
                    <Button icon="pi-md-import-export" onClick={this.descargarConstancia} label="Constancia" className="p-button flat-btn" />
                </div>
                <div className="P-col-12 p-md-3">
                    <Button icon="pi-md-import-export" onClick={this.descargarReporteExcel} label="Exportar a Excel" className="p-button flat-btn" />
                </div>
                <div className="P-col-12 p-md-3">
                    <Button icon="pi-md-import-export" onClick={this.descargarPdf} label="Constancias individuales" className="p-button flat-btn" />
                </div>
            </div>
        );

        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );


        return (<div>
            <Growl ref={(el) => (this.growl = el)} />
            <Lightbox target={visorPdfTarget}>
                <div id="contenedorIframe"  >
                    <iframe id="elIframe" src={iFrameSrc} width="1200px" height="650px" title="pdf"></iframe>
                </div>
            </Lightbox>
            <div className="card card-w-title">
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">Registro Patronal:</div>
                    <div className="P-col-12 p-md-10">
                        <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" 
                        filterBy="value,label" showClear={true}
                         placeholder="*Registro Patronal:" 
                         options={this.state.registrosPatronales} optionLabel="label"
                        value={objetoConsulta.empresa || ""} name="objetoConsulta.empresa" 
                        onChange={(e) => { this.asignarValores(e, false) }}
                            autoWidth={false} />
                        {errores.empresa ? (<div><br /> <Message severity="error" text={errores.empresa} />{" "}</div>) : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label >*Fechas de Transmisión</label>
                    </div>
                    {mostrarFecha ? calendarioFechaIncial : null}
                    <div className="p-col-12 p-md-2">
                        <label><center>y</center>  </label>
                    </div>

                    {mostrarFecha ? calendarioFechaFinal : null}
                    <div className="p-col-12 p-md-2">Lote IMSS:</div>
                    <div className="p-col-12 p-md-10">
                        <InputText placeholder="Lote IMSS" value={objetoConsulta.loteIdImss || ""} name="objetoConsulta.loteIdImss" onChange={(e) => { this.asignarValores(e, false) }}
                            className={errores.loteIdImss ? 'p-error' : ''} />
                        {errores.loteIdImss ? (<div><br /> <Message severity="error" text={errores.loteIdImss} />{" "}</div>) : null}
                    </div>
                </div>
                <div className="p-fluid">

                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <Button label="Limpiar" icon="pi-md-refresh" onClick={this.limpiarDatos.bind(this)} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Buscar" icon="pi-md-search" onClick={this.buscar.bind(this)} />
                        </div>
                        <div className="p-col-12 p-md-2">
                            {paginacion.datos != null && paginacion.datos.length > 0 ? <Button label="Descargar Respuesta" icon="pi-md-folder"
                                onClick={this.descargarRespuesta.bind(this)} /> : ""}
                        </div>
                    </div>

                </div>
            </div>

            <br /><br />
            <div className="p-grid p-fluid">
                <div className="p-col-12">
                    <DataTable value={paginacion.datos} editable={true} header="Lotes capturados" responsive={true} resizableColumns={true}>
                        <Column header="Lote" field="loteIdImss" autolayout={true} style={{ width: '70px', fontSize: '11px' }} />
                        <Column header="Registro patronal" field="registroPatronal" autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                        <Column header="Fecha Transmisión" body={this.formatoFecha.bind(this)} autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                        <Column header="Fecha Respuesta" body={this.formatoFechaRespuesta.bind(this)} autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                        <Column header="Estado" body={this.plantillaEstadoM.bind(this)} autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                        <Column header="Número de Movimientos" field="totalMovimientos" autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                        <Column header="Usuario" field="usuario" autolayout={true} style={{ width: '200px', fontSize: '11px' }} />
                        <Column header="Opciones" body={this.plantillaConsultar.bind(this)} autolayout={true} style={{ width: '100px', fontSize: '11px' }} />
                    </DataTable>
                    <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
                </div>
            </div>
            <Dialog header="Detalle del Lote" appendTo={document.body} visible={modalInformacionLote} modal={true}
                footer={dialogFooter} onHide={this.cerrarModalDetalleLote} style={{ width: '90%', height:'90%' }}>
                <div className="p-col-12">
                    <Growl ref={(el) => (this.growl = el)} />
                    <div className="p-grid p-fluid">
                        <div className="card">
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="lote">Lote:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{solicitudIdse.loteIdImss}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="registroPatronal">Registro patronal:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{solicitudIdse.registroPatronal}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="razonSocial">Razon social:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{solicitudIdse.razonSocial}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="fecha">Fecha de transmision:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{servicioFormatos.formatearFechaSinSegundos(solicitudIdse.fecha)}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="fechaRespuesta">Fecha de respuesta:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{servicioFormatos.formatearFechaSinSegundos(solicitudIdse.fechaRespuesta)}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="totalMovimientos">Total de movimientos:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    <label>{solicitudIdse.totalMovimientos}</label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="lote">Errores:</label>
                                </div>
                                <div className="p-col-12 p-md-4">
                                    {listaMovimientos.length === 0 ? "" : <label>{listaMovimientos[0].error}</label>}
                                </div>
                            </div>
                        </div>
                    </div>                
                    <div className="card">
                        <DataTable value={listaMovimientos} responsive={true} resizableColumns={true}>
                            <Column header="Movimiento" field="tipoMovimiento" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Enviados" field="total" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Errores" field="error" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Correctos" field="aceptados" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                        </DataTable>
                    </div>
                    
                    <br />                    
                    <div className="card">
                        <DataTable value={listaTrMovimientos} responsive={true} resizableColumns={true}>
                            <Column header="Tipo Movimiento" body={this.formatoTipoMovimiento} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Fecha Movto" body={this.formatofechaMovimiento} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="NSS" field="numeroSeguridadSocial" style={{ width: '60px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Nombre" body={this.templateNombre} style={{ width: '60px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="CURP" field="curp" style={{ width: '80px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="UMF" field="umf" style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="CveT" field="claveTrabajador" style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Tipo Trabajador" body={this.formatoTipoTrabajador} style={{ width: '70px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="SDI" body={this.formatosdi} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Extemporaneo" body={this.formatoExtemporaneo} style={{ width: '70px', fontSize: '10px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Tipo Salario" body={this.formatoTipoSalario} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Jornada" body={this.formatoTipoJornada} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Motivo de Baja" body={this.formatoBaja} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                            <Column header="Estado" body={this.formatoEstado} style={{ width: '50px', fontSize: '11px' }} autoLayout={true} resizableColumns={true} />
                        </DataTable>
                    </div>                    
                </div>
            </Dialog>
        </div >
        );
    }
}